import React from 'react';
import Box from '@mui/material/Box';
import Skeleton from '@mui/material/Skeleton';

import { styles } from '../WorkingHours.styles';

// Shown while the real /configuration response is loading, so the page doesn't
// briefly flash "all days disabled / no shifts" as if that were the real saved state.
const DayRowSkeleton = () => (
  <Box sx={styles.dayRow}>
    <Box sx={styles.dayHeaderRow}>
      <Box sx={styles.dayLeftSection}>
        <Skeleton variant="rounded" width={36} height={20} sx={{ borderRadius: '10px' }} />
        <Skeleton variant="text" width={90} height={24} />
      </Box>
    </Box>
    <Skeleton variant="rounded" height={38} sx={{ borderRadius: 1 }} />
    <Skeleton variant="text" width="100%" height={14} sx={{ marginTop: 0.25 }} />
  </Box>
);

export default DayRowSkeleton;
